import {
  AppBar,
  Container,
  createStyles,
  makeStyles,
  Theme,
  Toolbar,
} from "@material-ui/core";

import { OfqualLogo } from "../OfqualLogo";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flexGrow: 1,
    },
    appBar: {
      textAlign: "left",
      paddingLeft: 40,
    },
  })
);

export const Layout: React.FC = ({ children }) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Container>
        <AppBar className={classes.appBar}>
          <Toolbar>
            <OfqualLogo />
          </Toolbar>
        </AppBar>
        {children}
      </Container>
    </div>
  );
};
